
/**
 * 플랫폼 지원
 */
export type UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport = typeof UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport[keyof typeof UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
